
  import { Component, Prop, Vue } from "vue-property-decorator";
  import Tooltip from "@/components/common/Tooltip.vue";


  @Component({
    components: {
      Tooltip,
    },
  })
  export default class ManagerInvitationDisabledTooltip extends Vue {
    @Prop({type: Boolean, required: true}) readonly disabled!: boolean;
  }
